import React from "react";
import "./i18n";
import ReactDOM from "react-dom";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";

if (process.env.REACT_APP_ENV === "production") {
  const contentsquareScript = document.createElement("script");
  contentsquareScript.src = "https://t.contentsquare.net/uxa/afbb4a1d64892.js";
  contentsquareScript.async = true;
  document.head.appendChild(contentsquareScript);
}

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
